import React, { useState } from "react";
import { Link } from "react-router-dom";

const services = {
    "Food & Beverages": [
        "Home",
        "Subscription Management",
        "Client Management",
        "Order Management",
        "Settings",
        "User Managment",
        "Promotions & Discounts",
        "Account & History",
        "Reports & Analysis",
        "Inventory Management",
    ],
    "Fresh & Grocery": [
        "Home",
        "Subscription Management",
        "Client Management",
        "Order Management",
        "Settings",
        "User Managment",
        "Promotions & Discounts",
        "Account & History",
        "Reports & Analysis",
        "Inventory Management",
    ],
    "Catering & Services": [
        "Home",
        "Subscription Management",
        "Client Management",
        "Order Management",
        "Settings",
        "User Managment",
        "Promotions & Discounts",
        "Account & History",
        "Reports & Analysis",
        "Inventory Management",
    ],
    "Logistics & Supply": [
        "Home",
        "Subscription Management",
        "Client Management",
        "Order Management",
        "Settings",
        "User Managment",
        "Promotions & Discounts",
        "Account & History",
        "Reports & Analysis",
        "Inventory Management",
    ],
};

const ControlManagementPage = () => {
    const [checkedModules, setCheckedModules] = useState(
        Object.keys(services).reduce((acc, service) => {
            acc[service] = services[service].reduce((modAcc, module) => {
                modAcc[module] = false;
                return modAcc;
            }, {});
            return acc;
        }, {})
    );

    // true if all selected
    const allSelectedForService = (service) =>
        Object.values(checkedModules[service]).every(Boolean);

    // true if at least one selected
    const someSelectedForService = (service) =>
        Object.values(checkedModules[service]).some(Boolean);

    const handleSelectAllService = (service, isChecked) => {
        setCheckedModules({
            ...checkedModules,
            [service]: Object.keys(checkedModules[service]).reduce((acc, module) => {
                acc[module] = isChecked;
                return acc;
            }, {}),
        });
    };

    const handleModuleChange = (service, module) => {
        setCheckedModules({
            ...checkedModules,
            [service]: {
                ...checkedModules[service],
                [module]: !checkedModules[service][module],
            },
        });
    };

    const handleApply = (service) => {
        const selectedModules = Object.entries(checkedModules[service])
            .filter(([_, val]) => val)
            .map(([key]) => key);

        if (selectedModules.length === 0) {
            alert(`⚠ No modules selected for ${service}`);
        } else {
            alert(`✅ Applied for ${service}: \n${selectedModules.join(", ")}`);
        }
    };

    return (
        <div className="container-fluid" style={{ marginTop: "100px" }}>
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10" style={{ height: "500px" }}>


                    <div
                        style={{
                            padding: "20px",
                            fontFamily: "Arial, sans-serif",
                            marginTop: "30px",
                        }}
                    >
                        {/* Cards layout for services */}
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(30px, 1fr))",
                                gap: "20px",
                            }}
                        >
                            {Object.keys(services).map((service) => (
                                <div
                                    key={service}
                                    style={{
                                        backgroundColor: "#a055b0",
                                        padding: "20px",
                                        borderRadius: "12px",
                                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        maxWidth: "300px",
                                    }}
                                >
                                    <h3
                                        style={{
                                            borderBottom: "2px solid #eee",
                                            paddingBottom: "10px",
                                            color: "#fff",
                                            fontSize: "23px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {service}
                                    </h3>

                                    {/* Select All with indeterminate state */}
                                    <label style={{ fontWeight: "bold", color: "#fff" }}>
                                        <input
                                            type="checkbox"
                                            checked={allSelectedForService(service)}
                                            ref={(el) => {
                                                if (el) {
                                                    el.indeterminate =
                                                        someSelectedForService(service) &&
                                                        !allSelectedForService(service);
                                                }
                                            }}
                                            onChange={(e) =>
                                                handleSelectAllService(service, e.target.checked)
                                            }
                                            style={{ marginRight: "8px" }}
                                        />
                                        Select All
                                    </label>

                                    {/* Individual Modules */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "8px",
                                        }}
                                    >
                                        {services[service].map((module) => (
                                            <label
                                                key={module}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    background: "#f8f9fa",
                                                    padding: "8px 12px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    marginBottom: "0px",
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={checkedModules[service][module]}
                                                    onChange={() =>
                                                        handleModuleChange(service, module)
                                                    }
                                                    style={{ marginRight: "10px" }}
                                                />
                                                {module}
                                            </label>
                                        ))}
                                    </div>

                                    {/* Apply Button */}
                                    <div style={{ marginTop: "20px", textAlign: "center" }}>
                                        <button
                                            onClick={() => handleApply(service)}
                                            style={{
                                                background: "#4CAF50",
                                                color: "#fff",
                                                border: "none",
                                                padding: "8px 16px",
                                                borderRadius: "6px",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                transition: "0.3s",
                                            }}
                                            onMouseOver={(e) =>
                                                (e.target.style.background = "#43a047")
                                            }
                                            onMouseOut={(e) =>
                                                (e.target.style.background = "#4CAF50")
                                            }
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ControlManagementPage;
